import { render, staticRenderFns } from "./CollectionOptDetail.vue?vue&type=template&id=2795e94b&scoped=true"
import script from "./CollectionOptDetail.vue?vue&type=script&lang=js"
export * from "./CollectionOptDetail.vue?vue&type=script&lang=js"
import style0 from "./CollectionOptDetail.vue?vue&type=style&index=0&id=2795e94b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795e94b",
  null
  
)

export default component.exports